class OsmocamMainProduct extends HTMLElement {
  connectedCallback() {
    this.media = Array.from(this.querySelectorAll('[data-media-id]')).filter((node) => node.classList.contains('osmocam-product__media'));
    this.dots = Array.from(this.querySelectorAll('.osmocam-product__dot'));
    this.mediaCount = this.querySelector('[data-media-count]');
    this.accessoryMedia = Array.from(this.querySelectorAll('[data-accessory-media]'));
    this.accessoryDots = Array.from(this.querySelectorAll('[data-accessory-dot-index]'));
    this.accessoryMediaCount = this.querySelector('[data-accessories-media-count]');
    this.accessoryIndex = Math.max(0, this.accessoryMedia.findIndex((node) => node.classList.contains('is-active')));
    this.galleryPanels = Array.from(this.querySelectorAll('[data-gallery-panel]'));
    this.querySelectorAll('.ProductGallery__video-content___aHhO- video').forEach((video) => {
      video.addEventListener('click', (event) => {
        const videoRect = video.getBoundingClientRect();
        if (event.clientY - videoRect.top >= videoRect.height - 56) return;
        if (video.paused) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    });
    this.currentIndex = Math.max(0, this.media.findIndex((node) => node.classList.contains('is-active')));
    const variantData = this.querySelector('[data-bundle-variants]');
    this.variants = variantData ? JSON.parse(variantData.textContent) : [];
    this.form = this.querySelector('form[data-type="add-to-cart-form"]');
    this.submit = this.form?.querySelector('.osmocam-product__submit');
    this.dynamicCheckout = this.form?.querySelector('[data-dynamic-checkout]');
    this.dynamicCheckoutControl = this.form?.querySelector('[data-dynamic-checkout-control]');
    this.stickyPrice = this.querySelector('[data-sticky-price]');
    this.stickyAdd = this.querySelector('[data-sticky-add]');
    this.stickyBuy = this.querySelector('[data-sticky-buy]');
    this.quantityInput = this.querySelector('[data-quantity-input]');
    this.quantityMinus = this.querySelector('[data-quantity-minus]');
    this.quantityPlus = this.querySelector('[data-quantity-plus]');
    this.currentVariantPrice = null;
    this.currentVariantComparePrice = null;
    this.isAddingToCart = false;
    this.isBuyingNow = false;
    this.form?.addEventListener('submit', (event) => {
      if (event.submitter !== this.submit) return;
      event.preventDefault();
      this.addCurrentVariantToCart();
    });
    this.querySelector('[data-gallery-previous]')?.addEventListener('click', () => this.show(this.currentIndex - 1));
    this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.currentIndex + 1));
    this.querySelector('[data-accessories-previous]')?.addEventListener('click', () => this.showAccessory(this.accessoryIndex - 1));
    this.querySelector('[data-accessories-next]')?.addEventListener('click', () => this.showAccessory(this.accessoryIndex + 1));
    this.querySelectorAll('[data-dot-index]').forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        this.show(Number(dot.dataset.dotIndex));
      });
    });
    this.accessoryDots.forEach((dot) => {
      dot.addEventListener('click', () => this.showAccessory(Number(dot.dataset.accessoryDotIndex)));
    });
    this.querySelectorAll('[data-gallery-tab]').forEach((tab) => {
      const tabIndex = Array.from(this.querySelectorAll('[data-gallery-tab]')).indexOf(tab);
      tab.addEventListener('click', () => this.selectGalleryTab(tabIndex));
      tab.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.selectGalleryTab(tabIndex);
        }
      });
    });
    this.querySelectorAll('[data-bundle-input]').forEach((input) => {
      input.addEventListener('change', () => this.selectBundle(input));
    });
    this.stickyAdd?.addEventListener('click', (event) => {
      event.preventDefault();
      this.addCurrentVariantToCart();
    });
    this.stickyBuy?.addEventListener('click', (event) => {
      event.preventDefault();
      this.buyCurrentVariantNow();
    });
    this.quantityMinus?.addEventListener('click', () => this.decreaseQuantity());
    this.quantityPlus?.addEventListener('click', () => this.increaseQuantity());
    this.quantityInput?.addEventListener('input', () => this.validateQuantity());
    this.benefitModal = this.querySelector('[data-benefit-modal]');
    this.querySelectorAll('[data-benefit-modal-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => this.openBenefitModal());
    });
    this.querySelectorAll('[data-benefit-modal-close]').forEach((trigger) => {
      trigger.addEventListener('click', () => this.closeBenefitModal());
    });
    this.compareModal = this.querySelector('[data-compare-modal]');
    this.querySelector('[data-test-locator="btnOpenCompareBundle"]')?.addEventListener('click', () => {
      if (this.compareModal) this.compareModal.hidden = false;
    });
    this.querySelectorAll('[data-compare-close]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (this.compareModal) this.compareModal.hidden = true;
      });
    });
    this.benefitModal?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeBenefitModal();
    });
    this.selectGalleryTab(0);
    this.syncStickyAvailability();
    this.updateQuantityButtons();
    this.initializeVariantPrice();
  }

  show(index) {
    if (!this.media.length) return;
    this.currentIndex = (index + this.media.length) % this.media.length;
    this.media.forEach((media, mediaIndex) => {
      const active = mediaIndex === this.currentIndex;
      media.classList.toggle('is-active', active);
      media.classList.toggle('slick-active', active);
      media.classList.toggle('slick-current', active);
    });
    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === this.currentIndex;
      dot.classList.toggle('is-active', active);
      dot.classList.toggle('slick-active', active);
    });
    if (this.mediaCount) this.mediaCount.textContent = `${this.currentIndex + 1}/${this.media.length}`;
  }

  showAccessory(index) {
    if (!this.accessoryMedia.length) return;
    this.accessoryIndex = (index + this.accessoryMedia.length) % this.accessoryMedia.length;
    this.accessoryMedia.forEach((media, mediaIndex) => {
      media.classList.toggle('is-active', mediaIndex === this.accessoryIndex);
    });
    this.accessoryDots.forEach((dot, dotIndex) => {
      dot.closest('li')?.classList.toggle('is-active', dotIndex === this.accessoryIndex);
    });
    if (this.accessoryMediaCount) {
      this.accessoryMediaCount.textContent = `${this.accessoryIndex + 1}/${this.accessoryMedia.length}`;
    }
  }

  selectBundle(input) {
    this.querySelectorAll('[data-bundle-input]').forEach((bundleInput) => {
      bundleInput.closest('label')?.setAttribute('aria-checked', String(bundleInput === input));
    });
    const variant = this.variants.find((item) => String(item.id) === input.value);
    const mediaId = variant?.mediaId ? String(variant.mediaId) : input.dataset.mediaId;
    const mediaIndex = this.media.findIndex((media) => media.dataset.mediaId === mediaId);
    if (mediaIndex >= 0) this.show(mediaIndex);
    const price = this.querySelector('[data-product-price]');
    if (price && variant?.priceHtml) price.innerHTML = variant.priceHtml;
    if (this.submit) {
      const available = variant ? variant.available : input.dataset.available === 'true';
      this.submit.disabled = !available;
      this.submit.textContent = available ? this.dataset.addToCartLabel : this.dataset.soldOutLabel;
      if (this.stickyPrice && variant?.priceHtml) {
        this.extractAndStoreVariantPrices(variant.priceHtml);
        this.updateStickyPriceWithQuantity();
      }
      this.syncStickyAvailability();
    }
  }

  extractPrice(priceHtml) {
    const template = document.createElement('template');
    template.innerHTML = priceHtml;
    return template.content.querySelector('.style__block-price___\\+Ic1D')?.innerHTML ?? '';
  }

  syncStickyAvailability() {
    const disabled = Boolean(this.submit?.disabled);
    if (this.dynamicCheckout) {
      this.dynamicCheckout.classList.toggle('is-disabled', disabled);
      this.dynamicCheckout.setAttribute('aria-disabled', String(disabled));
    }
    if (this.dynamicCheckoutControl) this.dynamicCheckoutControl.inert = disabled;
    if (this.stickyAdd) {
      this.stickyAdd.disabled = disabled;
      this.stickyAdd.textContent = disabled ? this.dataset.soldOutLabel : this.dataset.addToCartLabel;
      this.stickyAdd.setAttribute('aria-disabled', String(disabled));
    }
    if (this.stickyBuy) {
      this.stickyBuy.hidden = disabled;
      this.stickyBuy.setAttribute('aria-disabled', String(disabled));
    }
  }

  async addCurrentVariantToCart() {
    if (!this.form || this.submit?.disabled || this.isAddingToCart) return;
    this.isAddingToCart = true;
    const data = new FormData(this.form);
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      });
      if (!response.ok) throw new Error('Unable to add item');
      const cartPromise = fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' }
      }).then((cartResponse) => cartResponse.json());
      const cartEvent = new CustomEvent('shopify:cart:lines-update');
      cartEvent.action = 'add';
      cartEvent.promise = cartPromise.then((cart) => ({ cart, detail: { itemCount: cart.item_count } }));
      document.dispatchEvent(cartEvent);
      document.querySelector('theme-drawer#cart-drawer')?.open();
    } catch (error) {
      console.warn('[osmocam] add to cart failed', error);
    } finally {
      this.isAddingToCart = false;
    }
  }

  async buyCurrentVariantNow() {
    if (!this.form || this.submit?.disabled || this.isBuyingNow) return;
    this.isBuyingNow = true;
    const data = new FormData(this.form);
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      });
      if (!response.ok) throw new Error('Unable to start checkout');
      window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
    } catch (error) {
      console.warn('[osmocam] buy now failed', error);
      this.isBuyingNow = false;
    }
  }

  openBenefitModal() {
    if (!this.benefitModal) return;
    this.benefitModal.hidden = false;
    document.body.classList.add('osmocam-modal-open');
    this.benefitModal.querySelector('.osmocam-benefit-modal__close')?.focus();
  }

  closeBenefitModal() {
    if (!this.benefitModal) return;
    this.benefitModal.hidden = true;
    document.body.classList.remove('osmocam-modal-open');
  }

  selectGalleryTab(index) {
    const tabs = Array.from(this.querySelectorAll('[data-gallery-tab]'));
    const panels = this.galleryPanels.length
      ? this.galleryPanels
      : Array.from(this.querySelectorAll('[data-gallery-panel]'));
    tabs.forEach((tab, tabIndex) => {
      const active = tabIndex === index;
      tab.classList.toggle('is-active', active);
      tab.querySelector('.ProductGallery__title___rU01g')?.classList.toggle('ProductGallery__active___CXg-y', active);
      tab.setAttribute('aria-selected', String(active));
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });
    panels.forEach((panel, panelIndex) => {
      const active = panelIndex === index;
      panel.classList.toggle('ProductGallery__active___CXg-y', active);
      panel.classList.toggle('ProductGallery__hidden___BOf4P', !active);
      panel.hidden = !active;
    });
    const activeBackground = this.querySelector('.osmocam-product__tab-active-bg');
    const activeTab = tabs[index];
    if (activeBackground && activeTab) {
      activeBackground.style.width = `${activeTab.offsetWidth}px`;
      activeBackground.style.transform = `translate3d(${activeTab.offsetLeft}px, 0, 0)`;
    }
  }

  decreaseQuantity() {
    if (!this.quantityInput) return;
    const currentValue = parseInt(this.quantityInput.value) || 1;
    const minValue = parseInt(this.quantityInput.min) || 1;
    const step = parseInt(this.quantityInput.step) || 1;
    const newValue = Math.max(minValue, currentValue - step);
    this.quantityInput.value = newValue;
    this.updateQuantityButtons();
    this.updateStickyPriceWithQuantity();
  }

  increaseQuantity() {
    if (!this.quantityInput) return;
    const currentValue = parseInt(this.quantityInput.value) || 1;
    const step = parseInt(this.quantityInput.step) || 1;
    const maxValue = parseInt(this.quantityInput.max) || Infinity;
    const newValue = Math.min(maxValue, currentValue + step);
    this.quantityInput.value = newValue;
    this.updateQuantityButtons();
    this.updateStickyPriceWithQuantity();
  }

  validateQuantity() {
    if (!this.quantityInput) return;
    let value = parseInt(this.quantityInput.value) || 1;
    const minValue = parseInt(this.quantityInput.min) || 1;
    const maxValue = parseInt(this.quantityInput.max) || Infinity;
    const step = parseInt(this.quantityInput.step) || 1;
    value = Math.max(minValue, Math.min(maxValue, value));
    const remainder = (value - minValue) % step;
    if (remainder !== 0) {
      value = value - remainder + (remainder >= step / 2 ? step : 0);
    }
    this.quantityInput.value = Math.max(minValue, value);
    this.updateQuantityButtons();
    this.updateStickyPriceWithQuantity();
  }

  updateQuantityButtons() {
    if (!this.quantityInput || !this.quantityMinus) return;
    const currentValue = parseInt(this.quantityInput.value) || 1;
    const minValue = parseInt(this.quantityInput.min) || 1;
    const maxValue = parseInt(this.quantityInput.max) || Infinity;
    const isAtMin = currentValue <= minValue;
    const isAtMax = currentValue >= maxValue;
    this.quantityMinus.classList.toggle('disabled', isAtMin);
    this.quantityMinus.disabled = isAtMin;
    if (this.quantityPlus) {
      this.quantityPlus.classList.toggle('disabled', isAtMax);
      this.quantityPlus.disabled = isAtMax;
    }
  }

  initializeVariantPrice() {
    const selectedInput = this.querySelector('[data-bundle-input]:checked');
    if (selectedInput) {
      const variant = this.variants.find((item) => String(item.id) === selectedInput.value);
      if (variant?.priceHtml) {
        this.extractAndStoreVariantPrices(variant.priceHtml);
      }
    } else {
      const priceElement = this.querySelector('[data-product-price]');
      if (priceElement) {
        this.extractAndStoreVariantPrices(priceElement.innerHTML);
      }
    }
  }

  extractAndStoreVariantPrices(priceHtml) {
    const template = document.createElement('template');
    template.innerHTML = priceHtml;
    const priceBlock = template.content.querySelector('.style__block-price___\\+Ic1D');
    if (!priceBlock) return;

    const discountPrice = priceBlock.querySelector('.style__discount-price___zH\\+UT');
    const normalPrice = priceBlock.querySelector('.style__normal-price___FcKyW');
    const originalPrice = priceBlock.querySelector('.style__original-price___McukH');

    if (discountPrice) {
      this.currentVariantPrice = this.extractPriceValue(discountPrice.textContent);
      this.currentVariantComparePrice = originalPrice ? this.extractPriceValue(originalPrice.textContent) : null;
    } else if (normalPrice) {
      this.currentVariantPrice = this.extractPriceValue(normalPrice.textContent);
      this.currentVariantComparePrice = null;
    }
  }

  extractPriceValue(priceText) {
    const match = priceText.match(/[\d,]+\.?\d*/);
    return match ? parseFloat(match[0].replace(/,/g, '')) : null;
  }

  formatPrice(price, currencySymbol = '$') {
    return `${currencySymbol}${price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  }

  updateStickyPriceWithQuantity() {
    if (!this.stickyPrice || !this.quantityInput || this.currentVariantPrice === null) return;

    const quantity = parseInt(this.quantityInput.value) || 1;
    const totalPrice = this.currentVariantPrice * quantity;
    const totalComparePrice = this.currentVariantComparePrice ? this.currentVariantComparePrice * quantity : null;

    const currencySymbol = this.detectCurrencySymbol();

    let priceHtml = '';
    if (totalComparePrice && totalComparePrice > totalPrice) {
      priceHtml = `
        <span class="style__price___D132C style__discount-price___zH+UT">${this.formatPrice(totalPrice, currencySymbol)}</span>
        <span class="style__price___D132C style__original-price___McukH">${this.formatPrice(totalComparePrice, currencySymbol)}</span>
      `;
    } else {
      priceHtml = `<span class="style__price___D132C">${this.formatPrice(totalPrice, currencySymbol)}</span>`;
    }

    this.stickyPrice.innerHTML = priceHtml;
  }

  detectCurrencySymbol() {
    const priceElement = this.querySelector('[data-product-price]');
    if (priceElement) {
      const text = priceElement.textContent;
      if (text.includes('$')) return '$';
      if (text.includes('€')) return '€';
      if (text.includes('£')) return '£';
      if (text.includes('¥')) return '¥';
    }
    return '$';
  }
}

if (!customElements.get('osmocam-main-product')) {
  customElements.define('osmocam-main-product', OsmocamMainProduct);
}
